import { Dtos } from "@inrev/common";
import { useFetchBondRequestPreviews } from "@portal/api/previews";
import {
	TrendMetricCard,
	type TrendMetricCardProps,
} from "@portal/components/patterns/metric-card";
import { useAuthenticatedUser } from "@portal/providers/AuthenticatedUserProvider";
import { useMemo } from "react";
import type { EntityScope } from "../../../shared/scope";
import { computeBondRequestMetrics } from "./computeBondRequestMetrics";

const EMPTY_BOND_REQUEST_PREVIEWS: Dtos.SuretyQuote.Preview.Get.Response[] = [];

type BondRequestMetricsViewProps = {
	scope: EntityScope;
};

export const BondRequestMetricsView = ({ scope }: BondRequestMetricsViewProps) => {
	const { user } = useAuthenticatedUser();
	const { bondRequestPreviews } = useFetchBondRequestPreviews();

	const metrics = useMemo(
		() =>
			computeBondRequestMetrics({
				bondRequestPreviews: bondRequestPreviews ?? EMPTY_BOND_REQUEST_PREVIEWS,
				scope,
				currentUserId: user.id,
			}),
		[bondRequestPreviews, scope, user.id],
	);

	const cards: TrendMetricCardProps[] = [
		{
			testId: "metric-total-open-requests",
			label: "Total Open",
			value: metrics.totalOpen,
			tone: "accent",
		},
		{
			testId: "metric-in-review-requests",
			label: "In Review",
			value: metrics.inReview,
			tone: "accent",
		},
		{
			testId: "metric-approved-requests",
			label: "Approved",
			value: metrics.approved,
			tone: "confirm",
		},
		{
			testId: "metric-accepted-requests",
			label: "Accepted",
			value: metrics.accepted,
			tone: "confirm",
		},
		{
			testId: "metric-pending-requests",
			label: "Pending",
			value: metrics.pending,
			tone: "neutral",
		},
	];

	return (
		<div className="grid max-w-8xl grid-cols-3 gap-4 lg:grid-cols-5">
			{cards.map((card) => (
				<TrendMetricCard key={card.testId} {...card} />
			))}
		</div>
	);
};
